/**
 * Created by Holger Szuesz <development@szuesz.de> on 18.07.2018 17:15
 */

import * as React from 'react';
import { NavLink } from 'react-router-dom';

import '../styles/Navigation.css';

class Navigation extends React.Component {
    public render() {
        return (
            <nav className="nav nav-masthead justify-content-center">
                <NavLink exact={true} to="/" className="nav-link" activeClassName="active" href="#">Home</NavLink>
                <NavLink exact={true} to="/Readinglist" className="nav-link" activeClassName="active" href="#">Bücherliste</NavLink>
                <NavLink exact={true} to="/Projects" className="nav-link" activeClassName="active" href="#">Projekte</NavLink>
                <NavLink exact={true} to="/Papers" className="nav-link" activeClassName="active" href="#">Arbeiten</NavLink>
            </nav>
        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.tsx